module.exports = __webpack_public_path__ + "static/globalcerti-361a661c87ef9d0c87de2758d1ed9bbf.png";